module.exports = "/assets/data/6b834040697bb9e325dec2dabe048de1-L25.data.json";